import script from "./UsersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersPage.vue?vue&type=script&setup=true&lang=js"

import "./UsersPage.vue?vue&type=style&index=0&id=3058da4c&scoped=true&lang=css"
script.__scopeId = "data-v-3058da4c"

export default script